function requireAll(r) {
    r.keys().forEach(r);
}

requireAll(require.context("../assets/images/logos/", true, /\.svg$/));
requireAll(require.context("../assets/images/email/", true, /\.png$/));
requireAll(require.context("../assets/images/social-meta-tag/", true, /\.png$/));
//requireAll(require.context("../../node_modules/@ubimax/frontend-resources/assets/images/logos/", true, /\.svg$/));
